import { ReactNode } from 'react';

type LandingRevealProps = {
  children: ReactNode;
  className?: string;
  delayClass?: string;
  /** Kept for API compatibility with call sites. */
  immediate?: boolean;
};

/**
 * Lightweight entrance wrapper. Avoids IntersectionObserver — the app scrolls inside a
 * fixed overflow container, which made IO-based reveals stay stuck at opacity:0.
 */
export default function LandingReveal({ children, className = '', delayClass = '' }: LandingRevealProps) {
  return <div className={`${className} landing-animate-in ${delayClass}`.trim()}>{children}</div>;
}
